export default __webpack_public_path__ + "static/media/logout.136b59f7.svg";